export enum SpliMode {
  ALL = "all",
  MANUAL = "manual",
  BLANK = "blank",
}
